export default "__VITE_ASSET__592abd41__"